<template>
  <div class="video-wrapper">
    <video
      v-if="media.type == 'video'"
      preload="none"
      muted
      loop
      playsinline
      autoplay
      :data-poster="media.preview_image">
      <source :src="videoSourceURL(media.sources)" />
      Sorry, your browser doesn't support embedded videos.
    </video>
  </div>
</template>

<script>
export default {
  name: 'VideoWrapper',

  props: {
    media: {
      type: Object,
      required: true
    }
  },

  methods: {
    videoSourceURL(sources) {
      let ten80
      let seven20
      let four80 = false
      for (const source of sources) {
        if (source.url.includes('1080p')) ten80 = source.url
        if (source.url.includes('720p')) seven20 = source.url
        if (source.url.includes('480p')) four80 = source.url
      }
      return ten80 || seven20 || four80 || sources.pop().url
    }
  }
}
</script>
